import { Skeleton } from '@fe-learner-common';
import { Page } from '@fe-learner-common/Page';
import { CourseCardGrid } from '@routes/catalog/components/CourseCardGrid';
import { useConfigContext } from '@fe-core';

const CategoriesSkeleton = () => {
  return (
    <div className="flex w-full flex-nowrap gap-2 overflow-hidden p-3 ">
      {Array.from({ length: 12 }).map((_, index) => (
        <Skeleton key={index} className="min-w-[100px]" type="button" />
      ))}
    </div>
  );
};

const CardSkeleton = () => (
  <div className="flex h-full cursor-pointer flex-col gap-3 rounded-2xl p-3 sm:m-0 sm:size-auto">
    <Skeleton type="card" />
    <Skeleton type="text" className="h-[24px] w-3/4" />
  </div>
);

const CardSkeletons = () => {
  return (
    <CourseCardGrid>
      {Array.from({ length: 12 }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </CourseCardGrid>
  );
};

export const CatalogSkeleton = () => {
  const { config } = useConfigContext();
  return (
    <div className="overflow-y-scroll">
      {!config.webfeatures?.['nextgenui-default'] && (
        <Skeleton
          type="text"
          className="h-[40px] w-full rounded-none bg-prominence-50"
        />
      )}

      <Page className="flex flex-col gap-3 ">
        <div className="md:space-y-3">
          <div className="flex items-center gap-2 px-4 pb-3">
            <Skeleton type="text" className="me-auto h-[30px] w-[200px] " />
            <Skeleton type="text" className=" h-[30px] w-[100px]" />
            <Skeleton type="text" className=" h-[30px] w-[100px]" />
            <Skeleton type="text" className="" />
          </div>
          <CategoriesSkeleton />

          <CardSkeletons />
        </div>
      </Page>
    </div>
  );
};
